import { render } from "./SocialFacebook.vue?vue&type=template&id=10c5bf6a"
import script from "./SocialFacebook.vue?vue&type=script&lang=js"
export * from "./SocialFacebook.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__